module.exports = __webpack_public_path__ + "static/media/dramatic-uluru.738055bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/dramatic-uluru.jpg
// module id = 131
// module chunks = 0